<script>
import { Bar, mixins } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import { addDots } from '@/core/helpers/temp/util.js'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  components: {
    ChartJSPluginDatalabels,
  },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    fontSize: String,
    color: String,
  },
  data() {
    return {
      //Chart.js options that control the appearance of the chart
      options: {
        spanGaps: false,
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'label',
          itemSort: function (a, b) {
            return b.datasetIndex - a.datasetIndex
          },
          callbacks: {
            label: function (t, d) {
              var dstLabel = d.datasets[t.datasetIndex].label
              var yLabel = t.yLabel
              return ' Total ' + '"' + dstLabel + '"' + ': ' + addDots(yLabel)
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
            formatter: (value, ctx) => {
              let chartData = ctx.chart.data.datasets
              let target = chartData[0].total

              const sum = target.filter(function (item) {
                return value === item.val
              })

              let percentage = (Number(value) / Number(sum[0].target)) * 100
              return percentage === '0%' ? '' : percentage.toFixed(1) + '%'
            },
            font: {
              weight: 'normal',
              size: this.fontSize,
            },
            color: this.color,
          },
        },
      },
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
